import { t } from 'i18next'
import React, { Fragment } from 'react'
import { useColumnSearchDispatch } from './hooks/useColumnSearchDispatch'
import Navigation from 'Components/Navigation'
import { TableSearchDocuments } from 'Components/TableSearchDocuments/TableSearchDocuments'
import { SearchSalesDocumentsProvider } from 'state/context/SearchSalesDocumentsContext'
import FilterSearchDocuments from 'Components/TableSearchDocuments/FiltersSearchDocuments/FilterSearchDocuments'
import SearchDocumentsNumberedPagination from 'Components/TableSearchDocuments/SearchDocumentsPagination/SearchDocumentsNumberedPagination'
import { searchDispatches } from 'api/mdl11/mdl11.services'
import {
  dispatchDocumentsSearchConfig,
  dispatchFilterFields,
} from './searchDispatchDocuments.config'

const DispatchFilter = () => (
  <FilterSearchDocuments
    fields={dispatchFilterFields}
    statusFilterKey="dispatch"
    filterButtonTestId="btn-filter-dispatches"
    clearButtonTestId="btn-clear-filters-dispatches"
  />
)

function SearchDispatch() {
  const { columns } = useColumnSearchDispatch()

  return (
    <SearchSalesDocumentsProvider
      fetcher={searchDispatches}
      initialFilters={dispatchDocumentsSearchConfig.initialFilters}
      buildPayload={dispatchDocumentsSearchConfig.buildPayload}>
      <Fragment>
        <Navigation />
        <section
          className="common-search-content"
          data-testid="container-search-dispatch">
          <header className="common-search-header">
            <h2>{t('DISPATCH_ORDER_T.DISPATCH_TITLE')}</h2>
          </header>
          <TableSearchDocuments
            columns={columns}
            FilterComponent={DispatchFilter}
            PaginationComponent={SearchDocumentsNumberedPagination}
          />
        </section>
      </Fragment>
    </SearchSalesDocumentsProvider>
  )
}

export default SearchDispatch
